import { render, staticRenderFns } from "./RoleChoose.vue?vue&type=template&id=ebf36556&scoped=true&"
import script from "./RoleChoose.vue?vue&type=script&lang=js&"
export * from "./RoleChoose.vue?vue&type=script&lang=js&"
import style0 from "./RoleChoose.vue?vue&type=style&index=0&id=ebf36556&lang=scss&scoped=true&"
import style1 from "./RoleChoose.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf36556",
  null
  
)

export default component.exports